export const ASSET_APP_IDS = {
  TABLES: "TableCLIAPI",
  INTERFACES: "InterfacesCLIAPI",
  CHATBOTS: "ChatbotsCLIAPI",
  AGENTS: "App222036CLIAPI",
} as const;

export const FALLBACK_IMPLEMENTATION_IDS = {
  AGENTS: "App222036CLIAPI@2.0.0",
  CHATBOTS: "ChatbotsCLIAPI@1.3.0",
  INTERFACES: "InterfacesCLIAPI@1.8.23",
  TABLES: "TableCLIAPI@1.19.0",
};
